module.exports = __webpack_public_path__ + "static/media/WA_footy_lives_here_logo-guernsey.6ddc8c10.png";